export interface WarehouseLevelDefinition {
  readonly level: number;
  readonly protectedPvPVolume: number;
}

/** The Warehouse never limits total village storage; levels only change PvP protection. */
export const WAREHOUSE_LEVELS = [
  { level: 1, protectedPvPVolume: 2_000 },
  { level: 2, protectedPvPVolume: 3_000 },
  { level: 3, protectedPvPVolume: 4_500 },
  { level: 4, protectedPvPVolume: 6_000 },
  { level: 5, protectedPvPVolume: 8_000 },
  { level: 6, protectedPvPVolume: 11_000 },
  { level: 7, protectedPvPVolume: 15_000 },
  { level: 8, protectedPvPVolume: 20_000 },
  { level: 9, protectedPvPVolume: 27_000 },
  { level: 10, protectedPvPVolume: 36_000 },
] as const satisfies readonly WarehouseLevelDefinition[];

export const WAREHOUSE_MAX_LEVEL = WAREHOUSE_LEVELS.at(-1)!.level;

/** MVP bootstrap matching the Hospital: expose the complete max-level configuration. */
export const WAREHOUSE_MVP_INITIAL_LEVEL = WAREHOUSE_MAX_LEVEL;

export function warehouseLevelDefinition(
  level: number,
): WarehouseLevelDefinition {
  if (!Number.isInteger(level) || level < 1 || level > WAREHOUSE_MAX_LEVEL)
    throw new RangeError(
      `warehouseLevel must be an integer from 1 to ${WAREHOUSE_MAX_LEVEL}`,
    );
  return WAREHOUSE_LEVELS[level - 1]!;
}
